// Shared device / capability checks for the "Report a Bug" screen capture.
//
// Task 24511 - the bug widget used to make these decisions in two places with
// two different rules (a user-agent regex in the trigger, window.innerWidth in
// the form), so an iPhone in landscape was "mobile" to one and "desktop" to the
// other. One set of checks now answers all of it.

export const isIOSDevice = () => {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent || "";
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  // iPadOS 13+ reports itself as a Mac, so the platform + touch pair is the
  // only reliable way to spot an iPad.
  return (
    /iPhone|iPod|iPad/i.test(ua) ||
    (navigator.platform === "MacIntel" && maxTouchPoints > 1)
  );
};

export const isTouchDevice = () => {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent || "";

  return (
    isIOSDevice() ||
    /Android|Mobi/i.test(ua) ||
    (navigator.maxTouchPoints || 0) > 1
  );
};

// getDisplayMedia (the browser's "choose what to share" picker) does not exist
// in iOS Safari at all, and every iOS browser is Safari underneath. Calling it
// there throws instantly, which is what made "Re-capture / choose window" look
// like a dead button on an iPhone.
export const canShareScreen = () => {
  if (typeof navigator === "undefined") return false;
  if (isIOSDevice()) return false;

  return typeof navigator.mediaDevices?.getDisplayMedia === "function";
};

// The point-and-click element picker is driven by mousemove + a hover
// highlight, so what it needs is a fine pointer to follow - not merely the
// absence of touch. A Windows touchscreen laptop has both, and should still get
// the picker; a phone has neither.
export const canPickElement = () => {
  if (typeof window === "undefined") return false;

  if (typeof window.matchMedia === "function") {
    return window.matchMedia("(pointer: fine)").matches;
  }

  return !isTouchDevice();
};
